import React from 'react'

export function folder() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 18" style={{enableBackground:"new 0 0 23 18"}} xmlSpace="preserve">
      <path className="fill" d="M1.3372093,0 C0.601021344,0 0,0.610740112 0,1.35883085 L0,16 C0,17 1,18 2,18 L21,18 C22,18 23,17 23,16 L23,5 C23,4 22,3 21,3 L11,3 L9.58611919,0.135883085 C9.5394207,0.0536466848 9.45387634,0.00213406665 9.36046512,0 L1.3372093,0 Z"></path>
    </svg>
  )
}
